import { Component, ViewChild, ElementRef } from '@angular/core';
import {
  IonicPage, NavController, NavParams,
  AlertController, Platform, ModalController,
  PopoverController
} from 'ionic-angular';
import { Storage } from '@ionic/storage'
import { ProductosProvider } from '../../providers/productos/productos'
import { LoadingController } from 'ionic-angular';
import { Observable } from 'rxjs/Observable';
import { CentroDeCostosProvider } from '../../providers/centro-de-costos/centro-de-costos'
import { CompaniasProvider } from '../../providers/companias/companias'

import { AuthService } from '../../providers/auth-service'
import JsBarcode from 'jsbarcode';
import { isUndefined } from '../../../node_modules/ionic-angular/umd/util/util';
import { MODO_DESCONECTADO,RUTA_MODO_DESCONECTADO, NUBE_AWS } from '../../config/url.servicio'
import { ElectronService } from 'ngx-electron';

import { UtilsProvider } from '../../providers/utils/utils'
import { ProductosElaboradosProvider } from '../../providers/productos-elaborados/productos-elaborados';
import { ImprimirGlobalComponent } from '../imprimir-global/imprimir-global';
import { ProductosCamposAdicionalesComponent } from '../../components/productos-campos-adicionales/productos-campos-adicionales';
import { ProductosCamposAdicionalesCambiarValorImpuestosComponent } from '../../components/productos-campos-adicionales-cambiar-valor-impuestos/productos-campos-adicionales-cambiar-valor-impuestos';

@IonicPage()
@Component({
  selector: 'page-productos',
  templateUrl: 'productos.html',
  providers: [ AuthService,ElectronService ]
})
export class ProductosPage {

  @ViewChild('fileInp') fileInput: ElementRef;
  @ViewChild('imagenProducto') imagenProducto: ElementRef;
  productos = []
  codigoProducto
  nombreProducto
  descripcion
  imagen
  costo
  valorVenta
  existenciasMinimas
  existenciasActuales
  visualizaEnCaja
  controlaEnInventario
  tipoImpuesto
  valorImpuesto
  productosId
  uuId
  centrosDeCostos = []
  loader
  typeImg
  imagenProd
  editarProducto

  centroDeCostosId: string
  allItems: any;
  buscar: any = "";
  companiasId:any = null
  fileUpload(event) {
    var reader = new FileReader();

    reader.onload = (e) => {
      this.imagenProducto['src'] = e.target['result'];
      this.imagen = e.target['result'];
    };

    reader.readAsDataURL(event.srcElement.files[0]);
    this.typeImg = event.srcElement.files[0].type
    this.imagenProd = event.srcElement.files[0]
  }

  onClick() {
    this.fileInput.nativeElement.click();
  }
  nombreCompaniaHeader:any=""
  nombreCargoHeader:any=""
  public picture;
  public codigoBarra:any =""
  @ViewChild('canvas') canvasElement : ElementRef;
  modo:boolean = MODO_DESCONECTADO === undefined ? true : MODO_DESCONECTADO
  controlaImpresorasEnRed: boolean = false;
  inputIP: string = ""
  isValidIP: boolean = true;
  nombreImpresora:string = ''
  ip:string = ''
  constructor(public navCtrl: NavController, public navParams: NavParams,
    public alertControllers: AlertController,
    public platforms: Platform,
    public modalControllers: ModalController,
    public servicio: ProductosProvider,
    private storage: Storage,
    public loadingCtrl: LoadingController,
    public serviciocentrodecosto: CentroDeCostosProvider ,
    public servicioCompania:CompaniasProvider,
    public auth: AuthService,
    private _electronService: ElectronService,
    public utils:UtilsProvider,
    private popoverCtrl: PopoverController,
    public servicioelaborado:ProductosElaboradosProvider,
  ) {
    this.servicioCompania.devolverVarios(['nombreCompania','nombreCargo','companiasId'])
      .then((val)=>{
        if(val){
          this.nombreCompaniaHeader = val['nombreCompania']
          this.nombreCargoHeader = val['nombreCargo']
          var valor = val['companiasId']
          this.companiasId = valor
          this.productos = []
          this.buscar = ""
          let tmodo = MODO_DESCONECTADO
          if(tmodo){
            let resultado = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos',RUTA_MODO_DESCONECTADO)
            if(resultado){

              this.productos = JSON.parse(resultado)
              this.allItems = JSON.parse(resultado)
            }

            let resultadocentroDeCostos = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-CentroDeCostos',RUTA_MODO_DESCONECTADO)
            if(resultadocentroDeCostos){

              this.productos = JSON.parse(resultadocentroDeCostos)
            }



          }else{
            this.cargarProductos();
            this.buscarCentrosDeCostosTodos();
            this.limpiar();
          }
        }
      })
  }

  ngAfterViewInit() {
    this.jsBarcodeVacio()
}

search(cantidadafn:any,i:any){
   this.storage.get('companiasId').then((val) => {
    let codigo = this.codigoProducto
    let codigoBarra = codigo
    JsBarcode(this.canvasElement.nativeElement, codigoBarra, {
      margin: 0,
      marginLeft: 0
    });
  });
 }

 searchFull(cantidadafn:any,i:any){
  JsBarcode(this.canvasElement.nativeElement, cantidadafn, {
    margin: 0,
    marginLeft: 0
  });
}

 searchEdit(cantidadafn:any,i:any){
  this.storage.get('companiasId').then((val) => {
   let companiasId = val
   let codigo = this.codigoProducto
   let nombreProducto = this.nombreProducto
   let codigoBarra = codigo + '-' + nombreProducto + '-' + companiasId
   JsBarcode(this.canvasElement.nativeElement, codigoBarra, {
     margin: 0,
     marginLeft: 0
   });
 });
}

  cerrarSession(){
    this.auth.logout()
    this.navCtrl.setRoot('LoginPage');
  }

  getItems(event: any): void {
    if(!this.allItems){
      let valores = this.productos
      this.allItems = valores;
    }
      this.productos = this.allItems.filter((item) => {
        return item.nombreProducto.toLowerCase().indexOf(this.buscar.toLowerCase()) > -1;
      });
}

onEvent(event: string, item: any){

if (event === 'onTextChange') {

 let valor = this.getItems(this.buscar);
 if(valor){
      item = valor
}
}
}

  cargarProductos() {
    this.productos = []
    this.buscar = ""

    this.servicio.buscarProductoCompania(this.companiasId)
    .subscribe(
      res => {
        this.productos = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        this.allItems = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
      },

      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se pudieron listar los productos, intente luego',
          buttons: ['Cerrar']
        });
        alert.present();
      }
    )

    this.servicioelaborado.buscarParametroGeneralIp(this.companiasId)
    .subscribe(
      res => {
        let responseControlaImpresora = !NUBE_AWS ? res[0] : JSON.parse(res['_body']).data[0]
        if(responseControlaImpresora.length > 0) {
          this.controlaImpresorasEnRed  = responseControlaImpresora[0].controlaImpresorasEnRed == 'S' ? true : false;
          this.ip = responseControlaImpresora[0].ip;
        }
      },
      err => {
        let alert = this.alertControllers.create({
          title: 'Error',
          subTitle: 'No se sabe si contrala impresara en red, intente luego',
          buttons: ['Cerrar']
        });
        this.controlaImpresorasEnRed = false
        alert.present();
      }
    )
  }

  guardar() {

    this.buscar = ""
    this.allItems = []
    let modod = MODO_DESCONECTADO
    let datosProducto: any = {
      codigoProducto: this.codigoProducto,
      nombreProducto: this.nombreProducto,
      descripcion: this.descripcion,
      imagen: this.imagenProd,
      costo: this.costo,
      valorVenta: this.valorVenta,
      existenciasMinimas: this.existenciasMinimas,
      existenciasActuales: this.existenciasActuales,
      visualizaEnCaja: this.visualizaEnCaja,
      controlaEnInventario: this.controlaEnInventario,
      tipoImpuesto: this.tipoImpuesto,
      valorImpuesto: this.valorImpuesto,
      centroDeCostosId: MODO_DESCONECTADO ? "1" : this.centroDeCostosId,
      productosId: this.productosId == undefined ? "0" : this.productosId,
      uuId:this.uuId,
      nombreImpresora: this.nombreImpresora
    }

    if(MODO_DESCONECTADO){
      this.modo = true
      this.storage.get('companiasId').then((val) => {
        datosProducto['companiasId'] = val
      let codigo = this.codigoBarra === "" ? this.buscarCodigoBarra(val) : this.codigoBarra

      datosProducto['codigoBarra'] = codigo

      let resultado = this._electronService.ipcRenderer.sendSync('guardar-mododesconectado-todos',datosProducto,'c:\\bd','productos')
         this.limpiar()

          let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos',RUTA_MODO_DESCONECTADO)
          if(resultadoNuevo){

            this.productos = []
            this.productos = JSON.parse(resultadoNuevo)
            this.allItems = JSON.parse(resultadoNuevo)
         }
        })
    } else{
    this.storage.get('companiasId').then((val) => {
      datosProducto['companiasId'] = val

      if(this.editarProducto){
        this.editarProducto = false;
        datosProducto['codigoBarra'] = this.codigoBarra
        this.editarProduct(datosProducto)
      } else {
        let codigo = this.codigoBarra === "" ? this.buscarCodigoBarra(val) : this.codigoBarra

        datosProducto['codigoBarra'] = codigo

        this.guardarProducto(datosProducto)
      }
    })
    }
  }

  buscarCodigoBarra(val:any){
      let codigo = this.codigoProducto
      let codigoBarra = codigo
      return codigoBarra

  }

  editarProduct(datosProducto) {
    datosProducto['productosId'] = this.productosId
    this.buscar =""
    this.allItems = []
    if(NUBE_AWS) {
      if(this.typeImg == undefined || (this.typeImg = 'image/png' && this.imagen == '') ){
        let datos: any = {
          companiasId: datosProducto.companiasId,
          queHago: "A",
          nombreTabla: "productos",
          name: "dataDynamicCrud",
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          prioridad: 0,
          codigoBarra: datosProducto.codigoBarra,
          codigoProducto: datosProducto.codigoProducto,
          nombreProducto: datosProducto.nombreProducto,
          descripcion: datosProducto.descripcion,
          costo: datosProducto.costo,
          valorVenta: datosProducto.valorVenta,
          existenciasMinimas: datosProducto.existenciasMinimas,
          existenciasActuales: datosProducto.existenciasActuales,
          visualizaEnCaja: datosProducto.visualizaEnCaja,
          controlaEnInventario: datosProducto.controlaEnInventario,
          tipoImpuesto: datosProducto.tipoImpuesto,
          valorImpuesto: datosProducto.valorImpuesto,
          centroDeCostosId: datosProducto.centroDeCostosId,
          productosId: datosProducto.productosId,
          uuId: datosProducto.uuId,
          estado: 0,
          nombreImpresora: datosProducto.nombreImpresora
        }
        this.servicio.editar(datos, this.typeImg).subscribe((data: any)=> {
          this.utils.mensajeMuestro('Productos','Modificado Exitosamente!','success')
          this.procesarResultado()
          this.typeImg
          this.imagenProd
        },(error) => {
          this.mostrarMensajeDeError('No se pudo actualizar el producto, intente luego')
          this.procesarResultado()
      })
      } else {
        this.servicio.guardarImagen(datosProducto, this.typeImg).subscribe((data: any)=> {
          let datos: any = {
            companiasId: datosProducto.companiasId,
            queHago: "A",
            nombreTabla: "productos",
            name: "dataDynamicCrud",
            imagen:data.link,
            imagenLocal: data.link,
            prioridad: 0,
            codigoBarra: datosProducto.codigoBarra,
            codigoProducto: datosProducto.codigoProducto,
            nombreProducto: datosProducto.nombreProducto,
            descripcion: datosProducto.descripcion,
            costo: datosProducto.costo,
            valorVenta: datosProducto.valorVenta,
            existenciasMinimas: datosProducto.existenciasMinimas,
            existenciasActuales: datosProducto.existenciasActuales,
            visualizaEnCaja: datosProducto.visualizaEnCaja,
            controlaEnInventario: datosProducto.controlaEnInventario,
            tipoImpuesto: datosProducto.tipoImpuesto,
            valorImpuesto: datosProducto.valorImpuesto,
            centroDeCostosId: datosProducto.centroDeCostosId,
            productosId: datosProducto.productosId,
            uuId: datosProducto.uuId,
            estado: 0,
            nombreImpresora: datosProducto.nombreImpresora
          }
          this.servicio.editar(datos, this.typeImg).subscribe((data: any)=> {
            this.utils.mensajeMuestro('Productos','Modificado Exitosamente!','success')
            this.procesarResultado()
            this.typeImg
            this.imagenProd
            this.navCtrl.setRoot('HomePage', {imagen: true, pages: 'ProductosPage'});
          },(error) => {
            this.mostrarMensajeDeError('No se pudo actualizar el producto, intente luego')
            this.procesarResultado()
        })
        }, (error) => {
          this.mostrarMensajeDeError('No se pudo actualizar el producto, intente luego')
          this.procesarResultado()
        })
      }

    } else {
      this.servicio.editar(datosProducto, this.typeImg)
      .subscribe(
        res => {
          this.utils.mensajeMuestro('Productos','Modificado Exitosamente!','success')
          this.procesarResultado()
        },
        err => { this.mostrarMensajeDeError('No se pudo actualizar el producto, intente luego')
        this.procesarResultado()
      }
      )
  }
  }

  guardarProducto(datosProducto){
    if(NUBE_AWS) {
      if(this.typeImg == undefined || (this.typeImg = 'image/png' && this.imagen == '') ){
        let datos: any = {
          companiasId: datosProducto.companiasId,
          queHago: "I",
          nombreTabla: "productos",
          name: "dataDynamicCrud",
          imagen:'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          imagenLocal: 'https://afnarqui.s3.us-east-1.amazonaws.com/sancolombia/sinimagen.png',
          prioridad: 0,
          codigoBarra: datosProducto.codigoBarra,
          codigoProducto: datosProducto.codigoProducto,
          nombreProducto: datosProducto.nombreProducto,
          descripcion: datosProducto.descripcion,
          costo: datosProducto.costo,
          valorVenta: datosProducto.valorVenta,
          existenciasMinimas: datosProducto.existenciasMinimas,
          existenciasActuales: datosProducto.existenciasActuales,
          visualizaEnCaja: datosProducto.visualizaEnCaja,
          controlaEnInventario: datosProducto.controlaEnInventario,
          tipoImpuesto: datosProducto.tipoImpuesto,
          valorImpuesto: datosProducto.valorImpuesto,
          centroDeCostosId: datosProducto.centroDeCostosId,
          productosId: datosProducto.productosId == undefined ? "0" : datosProducto.productosId,
          uuId: datosProducto.uuId,
          estado: 0,
          nombreImpresora: datosProducto.nombreImpresora
        }
        this.servicio.guardar(datos, this.typeImg).subscribe((data: any)=> {
          this.utils.mensajeMuestro('Productos','Guardado Exitosamente!','success')
          this.procesarResultado()
          this.typeImg
          this.imagenProd
        },(error) => {
          this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
          this.procesarResultado()
      })
      } else {
        this.servicio.guardarImagen(datosProducto, this.typeImg).subscribe((data: any)=> {
          let datos: any = {
            companiasId: datosProducto.companiasId,
            queHago: "I",
            nombreTabla: "productos",
            name: "dataDynamicCrud",
            imagen:data.link,
            imagenLocal: data.link,
            prioridad: 0,
            codigoBarra: datosProducto.codigoBarra,
            codigoProducto: datosProducto.codigoProducto,
            nombreProducto: datosProducto.nombreProducto,
            descripcion: datosProducto.descripcion,
            costo: datosProducto.costo,
            valorVenta: datosProducto.valorVenta,
            existenciasMinimas: datosProducto.existenciasMinimas,
            existenciasActuales: datosProducto.existenciasActuales,
            visualizaEnCaja: datosProducto.visualizaEnCaja,
            controlaEnInventario: datosProducto.controlaEnInventario,
            tipoImpuesto: datosProducto.tipoImpuesto,
            valorImpuesto: datosProducto.valorImpuesto,
            centroDeCostosId: datosProducto.centroDeCostosId,
            productosId: datosProducto.productosId == undefined ? "0" : datosProducto.productosId,
            uuId: datosProducto.uuId,
            estado: 0,
            nombreImpresora: datosProducto.nombreImpresora
          }
          this.servicio.guardar(datos, this.typeImg).subscribe((data: any)=> {
            this.utils.mensajeMuestro('Productos','Guardado Exitosamente!','success')
            this.procesarResultado()
            this.typeImg
            this.imagenProd
            this.navCtrl.setRoot('HomePage', {imagen: true, pages: 'ProductosPage'});
          },(error) => {
            this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
            this.procesarResultado()
        })
        }, (error) => {
          this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
          this.procesarResultado()
        })
      }
    } else {
    this.servicio.guardar(datosProducto, this.typeImg)
    .subscribe(
      res => {
        this.utils.mensajeMuestro('Productos','Guardado Exitosamente!','success')
        this.procesarResultado()
      },
      err => this.mostrarMensajeDeError('No se pudo guardar el producto, intente luego')
    )
   }
  }


  limpiar() {
    this.codigoProducto = ""
    this.nombreProducto = ""
    this.descripcion = ""
    this.imagenProd = ""
    this.costo = "0"
    this.valorVenta = "0"
    this.existenciasMinimas = "0"
    this.existenciasActuales = "0"
    this.visualizaEnCaja = 0
    this.controlaEnInventario = 0
    this.tipoImpuesto = "I"
    this.valorImpuesto = "0"
    this.imagen = ""
    this.centroDeCostosId = ""
    this.buscar =""
    this.allItems = []
    this.productosId = 0
    this.uuId = undefined
    this.codigoBarra = ""
    this.jsBarcodeVacio()
    this.nombreImpresora = ""
  }

  jsBarcodeVacio(){
    JsBarcode(this.canvasElement.nativeElement, 'No Definido', {
      background: "#ccffff"
    });
  }
  editar(item){

    this.codigoProducto = item.codigoProducto
    this.nombreProducto = item.nombreProducto
    this.descripcion = item.descripcion
    this.costo = item.costo
    this.valorVenta = item.valorVenta
    this.existenciasMinimas = item.existenciasMinimas
    this.existenciasActuales = item.existenciasActuales
    this.visualizaEnCaja = item.visualizaEnCaja === true ? 1 : 0;
    this.controlaEnInventario = item.controlaEnInventario === true ? 1 : 0;
    this.tipoImpuesto = item.tipoImpuesto
    this.valorImpuesto = item.valorImpuesto
    this.imagen = item.imagen
    this.productosId = item.productosId
    this.editarProducto = true
    this.buscar =""
    this.productosId = item.productosId
    this.uuId = item.uuid
    this.centroDeCostosId = item.centroDeCostosId
    this.nombreImpresora =  item.nombreImpresora
    this.allItems = []

    if(item.codigoBarra== null){
      this.searchEdit('','')
    }else{
      this.searchFull(item.codigoBarra,'')
      this.codigoBarra = item.codigoBarra
    }
  }



codigoBarraCuentos(valor) {

  let caracter = "-"
  let codigo  = valor.replace(/caracter/gi, "").length
  return codigo;
}

  eliminar(item) {
    this.utils.mensajeConfirmacionDos('Productos','¿Está Seguro de borrar el registro?','question','Si','No')
     .then((loQuiereBorrar: boolean) => {
      if (loQuiereBorrar) {
        this.buscar =""
        this.allItems = []
        if(MODO_DESCONECTADO === undefined){
          this.modo = true
        }else{
          this.modo = MODO_DESCONECTADO
        }
        if(this.modo){
          let resultadoNuevo = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos-eliminar',item)
          if(resultadoNuevo){

            this.limpiar()
            this.productos = []


            let valores = this._electronService.ipcRenderer.sendSync('buscar-informacion-mododesconectado-Productos')
            if(valores){

              this.productos = JSON.parse(valores)
            }
          }
        }else{
        this.servicio.eliminar(item)
        .subscribe(
          res => {
            this.utils.mensajeMuestro('Productos','Eliminado Exitosamente!','success')
            this.procesarResultado()
          },
          err => this.utils.mensajeMuestro('Productos','No se eliminó el producto','error')
          )
        }
      }
      else {
        this.utils.mensajeMuestro('Productos','No se eliminó el registro','warning')
      }
    })
  }

  procesarResultado() {
    this.limpiar()
    this.cargarProductos()
  }

  mostrarMensajeDeError(mensaje) {
    let alert = this.alertControllers.create({
      title: 'Error',
      subTitle: mensaje,
      buttons: ['Cerrar']
    });
    alert.present();
  }

  buscarCentrosDeCostosTodos(){
    this.storage.get('companiasId').then((val) => {
    this.centrosDeCostos = []
    this.serviciocentrodecosto.buscar('',val)
    .subscribe(
      (centrosCostos: any) => {
        let data : any = centrosCostos;
        this.centrosDeCostos = data
      },

      err => {
        this.utils.mensajeMuestro('Productos','No se encontraron Centros de Costos.','')
    });
  }
  )}

  imprimirGlobal(devolverNombreImpresora:string) {
    let popover = this.popoverCtrl.create(ImprimirGlobalComponent, { text: '',
      queHago:devolverNombreImpresora,
      cantidadImpresionesEnCaja: '1',
      ip:this.ip
    });
    popover.present({
      ev: ''
    });
    popover.onDidDismiss((data) => {
      if (data) {
        this.nombreImpresora = data
      }
    });
  }

  validateIP() {
    const ipPattern = /^(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.(25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
    this.isValidIP = ipPattern.test(this.nombreImpresora);
    if(!this.isValidIP) {
      this.utils.mensajeMuestro('Productos','Ip no valida','warning')
      this.nombreImpresora = ''
    }
  }


  camposAdicionales() {
    if(this.productosId == 0 || this.productosId == undefined) {
      this.utils.mensajeMuestro('Productos','Para gestionar campos adicionales debe estar actualizando un producto','warning')
      return
    }
    let modal = this.modalControllers.create(ProductosCamposAdicionalesComponent, { productosId: this.productosId, tipo: 'P' , nombreProducto:this.nombreProducto}, {
        cssClass: 'fullscreen-modal',
        enableBackdropDismiss: true
    })
    modal.present();

    modal.onDidDismiss(data => {
      if (data) {
      }
    })
    }


    actualizarImpuestos() {
      if(this.productosId == 0 || this.productosId == undefined) {
        this.utils.mensajeMuestro('Productos','Para actualizar impuestos debe estar actualizando un producto','warning')
        return
      }
      let modal = this.modalControllers.create(ProductosCamposAdicionalesCambiarValorImpuestosComponent, { productosId: this.productosId, tipo: 'P' , nombreProducto:this.nombreProducto}, {
          cssClass: 'fullscreen-modal',
          enableBackdropDismiss: true
      })
      modal.present();

      modal.onDidDismiss(data => {
        if (data) {
        }
      })
      }

}



// WEBPACK FOOTER //
// ./src/pages/productos/productos.ts